import React from 'react';
import ImageDisplay from '.';
import Magnify from 'src/assets/images/Magnify.svg';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { sizes } from 'src/styles/Media.styled';

const ImageButtonContainer = ({
    data,
    openImagePopup,
    slideWidth,
    centerMode,
    height,
    width
}) => {
    const { t } = useTranslation();
    const isCondensedView = useSelector(state => state.loginReducer.isCondensedView);
    const shouldShowMagnify = !(isCondensedView && window.innerWidth < sizes.mobileDevice);
    const marginLeft = centerMode && !isCondensedView ? '10px' : '0px';

    return (
        <div style={{ marginLeft }}>
            <ImageDisplay
                images={data?.productImages}
                showDots={false}
                slideWidth={slideWidth}
                centerMode={centerMode}
                height={height}
                width={width}
                openImagePopup={openImagePopup}
            />
            {shouldShowMagnify && (
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        marginTop: 5,
                        color: '#1010eb',
                        fontSize: 13,
                        fontFamily: 'AvenirNextWorld Regular',
                        cursor: 'pointer'
                    }}
                    id={`image-magnify-btn-${data?.id || 'default'}`}
                    onClick={openImagePopup}
                >
                    <img
                        style={{ height: 20, width: 30 }}
                        src={Magnify}
                        alt={t('ConsignmentAdd.common.bundleItems.createTemplate.viewLarger')}
                    />
                    <span style={{ marginLeft: 2 }}>
                        {t('ConsignmentAdd.common.bundleItems.createTemplate.viewLarger')}
                    </span>
                </div>
            )}
        </div>
    );
};

export default ImageButtonContainer;
